module.exports = __webpack_public_path__ + "static/media/sessions.f747cae1.svg";